import moment from 'moment'

const getOptions = ({
    categories,
    customTooltip,
    maxTrucksPerDay,
    theme,
}: {
    categories: string[],
    customTooltip: (args: any) => string,
    maxTrucksPerDay: number,
    theme: Record<string, any>,
}) => {
    return {
        legend: {
            horizontalAlign: 'left',
        } as ApexLegend,
        tooltip: {
            custom: customTooltip,
        },
        yaxis: [{
            labels: {
                formatter(val: number) {
                    return `${Math.round((val / maxTrucksPerDay) * 100)}%`
                },
            },
        }],
        chart: {
            id: 'bar',
            stacked: true,
            toolbar: {
                show: true,
                offsetX: -60,
                offsetY: 0,
                tools: {
                    download: '<img src="/assets/images/download_button.svg" width="24px" height="24px" alt="download"/>',
                },
            },
        },
        xaxis: {
            categories,
            labels: {
                formatter(value) {
                    return moment(value, 'DD.MM.YYYY').format('DD.MM')
                },
            },
        },
        colors: [
            theme.palette.primary[200],
            theme.palette.primary[700],
        ],
        dataLabels: {
            enabled: false,
        },
        grid: {
            padding: {
                right: 70,
                top: 20,
            },
            xaxis: {
                lines: {
                    show: true,
                },
            },
            strokeDashArray: 7,
        },
        annotations: {
            yaxis: [{
                y: maxTrucksPerDay,
                strokeDashArray: 10,
                borderColor: theme.palette.primary[800],
            }],
        },
    }
}

export default getOptions
